<div class="bannerImg">
    <ng-container>
        <div class="desktopScreen">
            <div class="d-flex justify-content-center mt-5 pt-4 mb-5"><img src="assets/img/svg/bankAccountLink.svg"
                    alt="" style="width: 158px; height: 143px;"></div>
            <div class="mt-4 ms-4">
                <p class="labelSubHead">Avail</p>
                <h3 class="labelHead">Personal Finance Manager</h3>
                <p class="labelSubHead">and manage your money smartly.</p>

            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 col-lg-12 ms-4">

                    <p class="labelSubHead my-4">Have complete banking details at one place!</p>
                    <div class="d-flex align-items-center" class="heading">
                        <div class="ps-3 py-2 errorMsg">Easily manage your money</div>
                    </div>
                    <div class="d-flex align-items-center" class="heading">
                        <div class="ps-3 py-2 errorMsg">Connect your bank account</div>
                    </div>
                    <div class="d-flex align-items-center" class="heading">
                        <div class="ps-3 py-2 errorMsg">Keep track of your income and expenses at one place</div>
                    </div>


                </div>
            </div>

        </div>
        <ng-container>
            <div class="userDetailsForm w-xl-25">
                <div class="row">
                    <form [formGroup]="userDetailsForm">
                        <label class="labelHeading">Give us few details to proceed</label>
                        <div class="col-md-12 col-sm-12  mt-3 form-group input-field-container">
                            <span id="isdCode" class="isd-code">+91</span>
                            <input type="tel" class="input-field" id="mob" pattern="^\d{10}$" formControlName="mobile"
                                (keyup)="formValidator.restrictCharacters($event, 'mobile')"
                                (keypress)="formValidator.IsNumeric($event)" (blur)="isdCodeStyle($event)"
                                (focus)="isdCodeStyle($event)" (focusout)="validateData()" maxlength="10" placeholder=""
                                [ngClass]="formValidator.FieldHasErrors(userDetailsForm,'mobile') ? 'invalid': ''">
                            <label for="mob" class="input-label">Mobile Number</label>
                            <div class="text-danger">
                                <div *ngIf="formValidator.HasError(userDetailsForm, 'mobile', 'required')">
                                    Mobile Number is mandatory
                                </div>
                                <div *ngIf=" (!formValidator.HasError( userDetailsForm,'mobile','required')
                                        && formValidator.HasError(userDetailsForm, 'mobile','invalidNumber'))
                                        || formValidator.HasError(userDetailsForm, 'mobile', 'pattern')">
                                    Please provide a valid mobile number to proceed further
                                </div>
                                <!-- <div *ngIf="showlinkExpireMsg">Your link has Expired</div> -->
                            </div>
        
                            <div class="">
                                <button class="btn mt-4  linkCta" type="submit" [disabled]="userDetailsForm.invalid" id="nextbtn" (click)="staticLinkFlow()">SUBMIT</button>
                            </div>
        
                        </div>
                    </form>
                </div>
            </div>
            
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!showUserDetailsMobScreen">
        <div class="d-flex justify-content-center align-items-center flex-column p-5 processConsent">
            <img src="assets/img/svg/bankAccountLink.svg" width="158px" height="143px">
            <p class="consentText">Congratulations! Your consent has been successfully captured. For the latest
                information, please check the Bajaj Markets app.</p>
        </div>
    </ng-container>


</div>